export default {
  strict: true,
  namespaced: true,
  state: {
    destination: null,
    favorite: {
      location: null,
      hotel: null
    },
    bedrooms: {
      single: {
        amount: 1,
        travellers: []
      },
      double: {
        amount: 0,
        travellers: []
      }
    },
    dates: {
      from: null,
      to: null
    },
    services: {
      breakfast: true,
      carpark: false,
      catering: false,
      disabled: false,
      internet: true
    },
    managers: [],
    filters: null,
    origPrices: null,
    context: 'online'
  },
  getters: {
    single: (state, getters) => {
      return state.bedrooms.single
    },
    double: (state, getters) => {
      return state.bedrooms.double
    },
    bedrooms: (state, getters) => {
      return {
        single: state.bedrooms.single,
        double: state.bedrooms.double
      }
    },
    from: (state, getters) => {
      return state.dates.from
    },
    to: (state, getters) => {
      return state.dates.to
    },
    favorite: (state, getters) => {
      return state.favorite
    },
    location: (state, getters) => {
      return state.favorite.location
    },
    hotel: (state, getters) => {
      return state.favorite.hotel
    },
    managers: (state, getters) => {
      return state.managers
    },
    context: (state, getters) => {
      return state.context
    },
    all: (state, getters) => {
      return state
    },
    form: (state, getters) => {
      var today = new Date()
      var tomorrow = new Date(); tomorrow.setDate(today.getDate() + 1)
      return {
        destination: state.destination,
        favorite: state.favorite,
        bedrooms: state.bedrooms,
        dates: {
          from: state.dates.from ? new Date(state.dates.from) : today,
          to: state.dates.to ? new Date(state.dates.to) : tomorrow
        },
        services: {
          catering: {
            value: 'catering',
            text: 'home.form.services.catering',
            selected: state.services.catering
          },
          carpark: {
            value: 'carpark',
            text: 'home.form.services.carpark',
            selected: state.services.carpark
          },
          breakfast: {
            value: 'breakfast',
            selected: state.services.breakfast
          },
          disabled: {
            value: 'disabled',
            selected: state.services.disabled
          },
          internet: {
            value: 'internet',
            selected: state.services.internet
          }
        },
        researchPriority: 'location',
        extra: '',
        customFields: [],
        managers: state.managers,
        context: state.context
      }
    }
  },
  mutations: {
    all (state, payload) {
      for (let key in payload) {
        if (payload.hasOwnProperty(key)) {
          if (typeof state[key] !== 'undefined') {
            state[key] = payload[key]
          }
        }
      }
    },
    breakfast (state, payload) {
      state.services.breakfast = payload
    },
    carpark (state, payload) {
      state.services.carpark = payload
    },
    catering (state, payload) {
      state.services.catering = payload
    },
    disabled (state, payload) {
      state.services.disabled = payload
    },
    internet (state, payload) {
      state.services.internet = payload
    },
    destination (state, payload) {
      state.destination = payload
    },
    favorite (state, payload) {
      state.favorite = payload
    },
    bedrooms (state, payload) {
      state.bedrooms = payload
    },
    dates (state, payload) {
      state.dates = payload
    },
    managers (state, payload) {
      state.managers = payload
    },
    context (state, payload) {
      state.context = payload
    },
    resetFilters (state, payload) {
      state.filters = null
      state.origPrices = null
    },
    reset (state, payload) {
      state.destination = null
      state.favorite = {
        location: null,
        hotel: null
      }
      state.bedrooms = {
        single: {
          amount: 1,
          travellers: []
        },
        double: {
          amount: 0,
          travellers: []
        }
      }
      state.dates = {
        from: null,
        to: null
      }
      state.services = {
        breakfast: true,
        carpark: false,
        catering: false,
        disabled: false,
        internet: true
      }
      state.managers = []
      state.filters = null
      state.origPrices = null
      state.context = 'online'
    }
  }
}
